export default "__VITE_ASSET__BSmH0806__"